/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["available-space-indicator{display:block;margin-top:25px}available-space-indicator .usage-info{margin:5px 0;font-size:1.3rem}available-space-indicator .upgrade-link-container{color:#1565c0}"];
export { styles as styles };
